import { useLocation } from "react-router-dom";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import SignIn from "layouts/authentication/sign-in";
import SignInMobile from "mobile/pages/auth/SignInMobile";
import { STOREFRONT_TENANTS } from "./registry";

/**
 * Tenant-aware sign-in routing.
 * Tenants with pages.signIn in their module (e.g. eds) always use it.
 * Others keep VBS sign-in (mobile → SignInMobile, desktop → shared SignIn).
 */
export default function StorefrontSignInRoute() {
  const location = useLocation();
  const { tenantKey } = useStorefrontTenant();
  const key = String(tenantKey || "").toLowerCase();
  const isMobile =
    location.pathname === "/m/authentication/sign-in" ||
    location.pathname.startsWith("/m/authentication/sign-in");

  const TenantSignIn = STOREFRONT_TENANTS[key]?.pages?.signIn;
  if (TenantSignIn) {
    return <TenantSignIn />;
  }

  if (isMobile) return <SignInMobile />;
  return <SignIn />;
}
